import React, { PureComponent } from 'react';
import { withStyles } from 'tss-react/mui';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { Map, List } from 'immutable';
import { TVA_A } from '@lba-dev/package.local-globals/tvaStatus';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import { connect } from 'react-redux';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import Grid from '@mui/material/Grid';

import { openCommAchat } from '../../actions/achat';
import { downloadAndSignBonSAV } from '../../actions/savIntervention';
import SuppliesRows from './SuppliesRows';
import CustomLoadingButton from '../Utils/CustomLoadingButton';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  buttonMargin: {
    margin: '1%'
  },
  saveButton: {
    marginRight: 8
  }
});

const path = ['supplies'];

class BodySupplies extends PureComponent {
  add = (data = {}, cb = f => f) => {
    const {
      price = 0,
      suppliesName = `Fourniture${price ? ' auto' : ''}`,
      pro = 'EDISON',
      attachment = ''
    } = data;
    const { setData, user, value } = this.props;
    const time = dayjs().format('LT').replace(':', 'h');
    const day = dayjs().format('L');
    const login = `${user.login} ${time} ${day}`;
    const supplie = new Map({
      suppliesDate: login,
      userId: user._id,
      date: new Date(),
      bl: 0,
      suppliesName,
      qt: 1,
      ut: price || 0,
      montant: price,
      pro,
      validate: false,
      attachment
    });
    const newProductState = value.push(supplie);
    setData(path, newProductState, cb);
  }

  popUpBon = () => {
    const { getData, save, downloadAndSignBonSAV } = this.props;
    const inter = {
      _id: getData(['_id']),
      id: getData(['id']),
      login: (getData(['login']) || new Map()).toJS(),
      createdFrom: (getData(['createdFrom']) || new Map()).toJS(),
      dropbox: (getData(['dropbox']) || new List()).toJS(),
    };
    const artisan = (getData(['currentArtisan']) || new Map()).toJS();
    const price = '0';
    downloadAndSignBonSAV({
      price,
      inter,
      artisan,
      add: this.add,
      save,
    });
  };

  setData = (pos, k, v, { cb = f => f, montant } = {}) => {
    const hasTobeNumber = ['qt', 'ut'];
    const valueToSet = hasTobeNumber.includes(k[0]) ? Number(v) : v;
    const { value, setData } = this.props;
    let res = value.setIn([pos, ...k], valueToSet);
    if (montant !== undefined) {
      res = res.setIn([pos, 'montant'], montant);
    }
    setData(path, res, cb);
  }

  remove = (id) => {
    const { value, setData } = this.props;
    setData(path, value.delete(id));
  }

  swap = (id) => {
    const { value, setData } = this.props;
    setData(
      path,
      value.withMutations((e) => {
        const tmp = e.get(id);
        return e.set(id, e.get(id + 1)).set(id + 1, tmp);
      })
    );
  }

  openDialogCommentaire = () =>
    openCommAchat(this.props)

  render() {
    const {
      classes, value, user, tva, getData,
      showSaveButton,
      save, merge,
      loadingSaveButton,
      readOnly
    } = this.props;

    const columns = [
      { id: 1, width: 2 },
      { id: 2, width: 15 },
      { id: 3, width: 10 },
      { id: 4, width: 38 },
      { id: 5, width: 5 },
      { id: 6, width: 10 },
      { id: 7, width: 10 },
      { id: 8, width: 10 },
      { id: 9, width: 10 },
      { id: 10, width: 2 }
    ];

    const headers = [
      { id: 0, label: '', },
      { id: 1, label: 'Le' },
      { id: 2, label: 'BL' },
      { id: 3, label: 'Désignation' },
      { id: 4, label: 'Quant' },
      { id: 5, label: 'PrixUnit' },
      { id: 6, label: `Montant ${tva === TVA_A ? 'HT' : 'TTC'}` },
      { id: 7, label: 'Fournisseur' },
      { id: 8, label: 'fichiers' },
      { id: 9, label: 'Envoyer au sst' },
      { id: 10, label: 'Modif' }
    ];


    return (
      <div>
        <form className={classes.container} noValidate>
          <Table className={classes.table}>
            <colgroup key="tableStyle">
              {columns.map((e) => (
                <col key={e.id} style={{ width: `${e.width}%` }} />
              ))}
            </colgroup>
            <TableHead key="tableHeaderLine">
              <TableRow>
                {headers.map((e) => (
                  <TableCell key={e.id}>{e.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody key="tableBodyLine">
              <SuppliesRows
                interId={getData && getData(['id'])}
                data={value}
                artisan={getData && (
                  getData(['currentArtisan']) || new Map()
                ).toJS()}
                setData={this.setData}
                remove={this.remove}
                swap={this.swap}
                readOnly={readOnly}
              />
            </TableBody>
          </Table>
        </form>
        {!readOnly && (
          <Grid container alignItems="center">
            <Grid item xs={12} sm={10}>
              <Button
                variant="contained"
                size="small"
                className={classes.buttonMargin}
                onClick={this.add}
              >
                Ajout FOURNITURE
              </Button>
              {permit(user, { key: 'bonsDeCommande' }) && getData && (
                <Button
                  variant="contained"
                  size="small"
                  className={classes.buttonMargin}
                  onClick={this.popUpBon}
                >
                  Télécharger et signer
                </Button>
              )}
              <Button
                variant="contained"
                size="small"
                disabled={isNaN(merge.get('id'))}
                className={classes.buttonMargin}
                onClick={this.openDialogCommentaire}
              >
                Commentaire Achat
              </Button>
            </Grid>
            {showSaveButton && (
              <Grid item xs={12} sm={2} align="right">
                <CustomLoadingButton
                  variant="contained"
                  className={classes.saveButton}
                  size="small"
                  color="secondary"
                  children={'Enregistrer'}
                  onClick={() => save()}
                  loading={loadingSaveButton}
                />
              </Grid>
            )}
          </Grid>
        )}
      </div>
    );
  }
}

export default connect(null, { downloadAndSignBonSAV })(
  withStyles(BodySupplies, styles)
);
